import Home from './pages/Home'
import Detail from './pages/Details'
import DetailPackage from './pages/Package'
import Rating from './pages/Rating'
import Rating2 from './pages/Rating2'
import Wp from './pages/Wp'
import Finish from './pages/Finish'
import Devolution from './pages/Devolution'
import { Route, useLocation, Routes, Outlet } from 'react-router-dom'
import Navbar from './pages/NavBar'
import ShortCode from './pages/ShortCode'
import { connect } from 'react-redux'
import PackageDevloutionDetail from './pages/Devolution/details'
import NpsPage from './pages/Nps'
import Chat from './pages/Chat'

const RoutesSystem = ({ showNavbar, brandSettings, globalColors }) => {
    const location = useLocation()

    const show =
        location.pathname !== '/returndetail' &&
        !location.pathname.includes('/devolutiondetail')
    const validNavbar = brandSettings.show_toolbar && showNavbar && show
    return (
        <div
            className="flex flex-col mx-auto relative"
            style={{
                height: '100dvh',
                maxWidth: 600,
                background: 'var(--background-color)',
            }}
        >
            <div
                className="flex w-full"
                style={{
                    height: `calc(100dvh - ${validNavbar ? '70px' : '0px'})`,
                }}
            >
                <Routes>
                    <Route path="/s/:id" element={<ShortCode />} />
                    <Route path="/chat/:channel/:id" element={<Chat />} />
                    <Route path="/wp/:id" element={<Wp />} />
                    <Route path="/nps/:id" element={<NpsPage />} />
                    <Route
                        path="/devolutiondetail/:id"
                        element={<PackageDevloutionDetail />}
                    />
                    <Route path="/ordersuser/:marca" element={<Home />} />
                    <Route path="/nps/:id" element={<Rating />} />
                    <Route path="/nps2/:id" element={<Rating2 />} />
                    <Route
                        path="/packagedetail/:id"
                        element={<DetailPackage />}
                    />
                    <Route path="/returndetail" element={<Devolution />} />
                    <Route path="/recordnpsuser" element={<Rating />} />
                    <Route path="/finish" element={<Finish />} />
                    <Route path="/:id" element={<Detail />} />
                    <Route
                        path="*"
                        element={
                            <div className="w-full bg-white flex flex-col justify-center items-center h-screen">
                                <img
                                    src="/images/app_package2.gif"
                                    alt="icon"
                                    style={{ height: 190 }}
                                />
                                <span>App MeuPedi.do</span>
                            </div>
                        }
                    />
                </Routes>
            </div>
            {validNavbar && <Navbar />}
        </div>
    )
}
export default connect((state) => ({
    showNavbar: state?.showNavbar,
    brandSettings: state?.brandSettings,
    globalColors: state?.globalColors,
}))(RoutesSystem)
